import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { GetLookupRequest, Lookup } from "../../domain";
import { Observable } from "rxjs";
import { LookupsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetLookupPlansUsecase implements UseCase<GetLookupRequest, Lookup[]> {

  constructor(private readonly lookupsRepository: LookupsRepository) {
  }

  execute(params: GetLookupRequest): Observable<Lookup[]> {
    return this.lookupsRepository.getLookupPlan(params);
  }

}
